var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.5em",
    height: "1.5em",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1235 2549 c-31 -17 -1204 -1191 -1221 -1221 -36 -69 11 -148 90 -148 13 0 40 11 60 25 l36 24 0 -584 0 -584 24 -28 24 -28 1032 0 1032 0 24 28 24 28 0 584 0 584 36 -24 c20 -14 47 -25 60 -25 75 0 126 78 93 143 -16 31 -1188 1205 -1221 1223 -32 17 -65 18 -93 3z m487 -676 l438 -438 0 -617 0 -618 -195 0 -195 0 0 363 c0 355 0 364 -21 386 -11 12 -32 26 -46 32 -32 12 -814 12 -846 0 -14 -6 -35 -20 -46 -32 -21 -22 -21 -31 -21 -386 l0 -363 -195 0 -195 0 0 617 0 618 437 437 c241 241 440 438 443 438 3 0 202 -197 442 -437z m-152 -1378 l0 -295 -290 0 -290 0 0 295 0 295 290 0 290 0 0 -295z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.34385f04e9ccac6dc92d758d50a94201.svg";
export { ForwardRef as ReactComponent };